module.exports = __webpack_public_path__ + "874ef9d4216581345a2a7be650fbe466.pdf";